// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__iXxU_","title":"Card_title__1c-aP","card_text":"Card_card_text__yjRI_","img":"Card_img__1ID3D"};